import React from 'react';
import { useSearchParams } from 'react-router-dom';

import { AuthService, Container } from '../../../../symphony';

import {
	orderFilerTypeAlias,
	CODE_BITS_LIST_COUNT,
	SlCodeBitsContext,
} from '../../global-constants';
import { SlDataService } from '../../services/sl-data.service';
import { SlActions } from '../../services/ActionsService/sl-actions';
import { ActionType, RequestType } from '../../global-interface';
import { useContainerData } from '../../../../shared/public/SlHooks/useContainerData';
import { PaginationItem } from '../../../../shared/public/SlPagination/types';
import { SlPagination } from '../../../../shared/public/SlPagination/SlPagination';

export function CodeBitsPaginationContainer() {
	const { actions$ } = Container.take(SlCodeBitsContext, SlActions);
	const isLoggedIn = Container.take('global', AuthService).isLoggedIn();
	const [searchParams] = useSearchParams();
	const orderFilter = searchParams.get('ordering') || Object.values(orderFilerTypeAlias)[0];
	const isMyCodeBits = orderFilter === 'MyCodeBits';
	const {
		codeBitsList$: codeBitsList,
		codeBitsListCount$: codeBitsListCount,
	} = useContainerData(SlCodeBitsContext, SlDataService, [
		'codeBitsList$',
		'codeBitsListCount$',
	]);

	if (!codeBitsList || (isMyCodeBits && !isLoggedIn)) return null;

	const handleItemClick = (item: PaginationItem) => {
		actions$.next({
			type: ActionType.OnPaginationClick,
			requestType: RequestType.Parallel,
			data: item,
		});
	};

	return (
		<SlPagination
			totalCount={codeBitsListCount}
			rowsPerPage={CODE_BITS_LIST_COUNT}
			onItemClick={handleItemClick}
		/>
	);
}
